import { Row } from "react-bootstrap";
import Select from "react-select";

const CustomSelect = ({ options, handleChange, placeholder, defaultValue }) => {
  return (
    <Row>
      <Select
        onChange={(e) => handleChange(e)}
        options={options}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={defaultValue}
      />
    </Row>
  );
};

export default CustomSelect;
